/*global window*/

/**
 * if adobeDTM will get blocked will have a stub that will prevent exceptions
 */
(function (MOVE) {
    "use strict";

    var init = function () {
        //it will prevent the back-forward cache for the Safari browser.
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    };

    MOVE.addWorkaround({
        init: init
    });

}(MOVE || {}));



// WEBPACK FOOTER //
// ./_workarounds/workaround_safari.js